import { type BreadCrumbData, getBreadcrumbSchema } from "lib/schema";
import Head from "next/head";

interface Props {
  key?: string;
  html: string;
}

export function JSONLd(props: Props) {
  const { key, html } = props;

  return (
    <Head>
      {/* Check https://nextjs.org/learn/seo/rendering-and-ranking/metadata */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: html }} key={key} />
    </Head>
  );
}

interface BreadCrumbProps {
  data: BreadCrumbData;
}

export function JSONLdBreadcrumb(props: BreadCrumbProps) {
  const { data } = props;

  return <JSONLd html={getBreadcrumbSchema(data)} />;
}
